
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7DyRn", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f73759c8512f71$export$2e2bcd8739ae039);
var $58f73759c8512f71$export$2e2bcd8739ae039 = {
    codeHasBeenCompiled: false,
    vmIsAlive: false,
    keyboardLocked: false,
    vmInited: false,
    UPS: 30,
    /**
     * @type {AudioContext}
     */ audioContext: null,
    /**
     * @type {OscillatorNode}
     */ oscillator: null,
    /**
     * @type {GainNode}
     */ audioVolume: null,
    /**
     * @type {MediaStreamAudioDestinationNode}
     */ audioMediaStreamDestination: null,
    soundStarted: false,
    mouseOverDisplay: false,
    keysDown: [],
    keysUp: [],
    videoText: "",
    ioBulbs: {},
    ioBulbNames: [
        "io00",
        "io01",
        "io02",
        "io03",
        "io04",
        "io05",
        "io06",
        "io07"
    ],
    /** @type {{register: string, enabled: boolean}[]} */ switchQueue: [],
    compileFailed: false,
    errorDiv: null,
    errorCount: 0,
    registerPeekValue: null,
    currentRegPeekValue: null,
    prevRegPeekValue: null,
    focusedFile: "main.gpasm"
};
window.textureData = new Uint8Array(new SharedArrayBuffer(230400));

});

parcelRegister("hF90B", function(module, exports) {

$parcel$export(module.exports, "ErrorTypes", () => $cdbd40ee5895e9e8$export$43a750ddd9f2303e);
$parcel$export(module.exports, "ShowError", () => $cdbd40ee5895e9e8$export$9074993ebbe8f4e1);
// Handle showing errors

var $7DyRn = parcelRequire("7DyRn");
var $cdbd40ee5895e9e8$export$43a750ddd9f2303e = {
    Success: 0,
    Error: 1
};
function $cdbd40ee5895e9e8$var$generateErrorHtml(error_type, data) {
    if (error_type == $cdbd40ee5895e9e8$export$43a750ddd9f2303e.Success) return {
        Header: `${data.Header}`,
        HeaderClass: "good-error",
        Body: `<p>${data.Body}</p>`
    };
    else {
        let lines = data.Body.split(/\r?\n/);
        return {
            Header: `${data.Header}`,
            HeaderClass: "bad-error",
            Body: `
            <p>${lines[1].replace(`'`, "")}</p>
            <code class="table-code">${lines[2]}</code>
            <p>${lines[3]}</p>
            `
        };
    }
}
function $cdbd40ee5895e9e8$export$9074993ebbe8f4e1(type, text) {
    var error_html = null;
    switch(type){
        case $cdbd40ee5895e9e8$export$43a750ddd9f2303e.Success:
            error_html = $cdbd40ee5895e9e8$var$generateErrorHtml($cdbd40ee5895e9e8$export$43a750ddd9f2303e.Success, {
                Header: "Success",
                Body: text
            });
            break;
        case $cdbd40ee5895e9e8$export$43a750ddd9f2303e.Error:
            if (text.includes("error")) (0, $7DyRn.default).compileFailed = true;
            error_html = $cdbd40ee5895e9e8$var$generateErrorHtml($cdbd40ee5895e9e8$export$43a750ddd9f2303e.Error, {
                Header: "Error",
                Body: text
            });
            break;
        default:
            break;
    }
    var error_container = document.createElement("section");
    error_container.classList.add("rounded-lg", "w-full", "p-3");
    var header = document.createElement("h1");
    header.classList.add(error_html.HeaderClass);
    header.textContent = error_html.Header;
    error_container.appendChild(header);
    error_container.insertAdjacentHTML("beforeend", error_html.Body);
    if ((0, $7DyRn.default).errorCount == 0) (0, $7DyRn.default).errorDiv.replaceChildren();
    (0, $7DyRn.default).errorCount++;
    (0, $7DyRn.default).errorDiv.appendChild(error_container);
}

});

parcelRegister("bNfEN", function(module, exports) {

$parcel$export(module.exports, "goputer", () => $89606a79fcd6d3b6$export$402237f6bb0af782);
$parcel$export(module.exports, "interruptInts", () => $89606a79fcd6d3b6$export$3eaa7541cf5eefb2);
$parcel$export(module.exports, "registerInts", () => $89606a79fcd6d3b6$export$97def26f76d9b286);
$parcel$export(module.exports, "instructionArray", () => $89606a79fcd6d3b6$export$d0584c88f433914d);
$parcel$export(module.exports, "interruptArray", () => $89606a79fcd6d3b6$export$ab0d25692b300f0a);

var $dLq9J = parcelRequire("dLq9J");

var $hF90B = parcelRequire("hF90B");

// Wrapper for worker, also contains types that can be cached, the interrupt and register maps.
/** @type {import("./goputer.worker").Goputer} */ const $89606a79fcd6d3b6$export$402237f6bb0af782 = $dLq9J.wrap(new Worker((parcelRequire("8N69w"))));
$89606a79fcd6d3b6$export$402237f6bb0af782.onerror = $dLq9J.proxy((0, $hF90B.ShowError));
const $89606a79fcd6d3b6$export$3eaa7541cf5eefb2 = {
    "ss": 0,
    "sf": 1,
    "va": 2,
    "vp": 3,
    "vt": 4,
    "vc": 5,
    "vi": 6,
    "vl": 7,
    "iof": 8,
    "ioc": 9,
    "vf": 10,
    //Subscribable interrupts
    "mm": 11,
    "mu": 12,
    "md": 13,
    "io08": 14,
    "io09": 15,
    "io10": 16,
    "io11": 17,
    "io12": 18,
    "io13": 19,
    "io14": 20,
    "io15": 21,
    "ku": 22,
    "kd": 23,
    "err": 24
};
const $89606a79fcd6d3b6$export$97def26f76d9b286 = {
    "r00": 0,
    "r01": 1,
    "r02": 2,
    "r03": 3,
    "r04": 4,
    "r05": 5,
    "r06": 6,
    "r07": 7,
    "r08": 8,
    "r09": 9,
    "r10": 10,
    "r11": 11,
    "r12": 12,
    "r13": 13,
    "r14": 14,
    "r15": 15,
    "vx0": 16,
    "vy0": 17,
    "vx1": 18,
    "vy1": 19,
    "vc": 20,
    "vb": 21,
    "vt": 22,
    "kc": 23,
    "kp": 24,
    "mx": 25,
    "my": 26,
    "mb": 27,
    "st": 28,
    "sv": 29,
    "a0": 30,
    "d0": 31,
    "stk": 32,
    "stz": 33,
    "io00": 34,
    "io01": 35,
    "io02": 36,
    "io03": 37,
    "io04": 38,
    "io05": 39,
    "io06": 40,
    "io07": 41,
    "io08": 42,
    "io09": 43,
    "io10": 44,
    "io11": 45,
    "io12": 46,
    "io13": 47,
    "io14": 48,
    "io15": 49,
    "prc": 50,
    "cstk": 51,
    "cstz": 52,
    "dl": 53,
    "dp": 54,
    "sw": 55,
    "ctrl": 56,
    "tsc": 57
};
const $89606a79fcd6d3b6$export$a8647fae84abf3c8 = {
    "mov": 0,
    "jmp": 1,
    "add": 2,
    "mul": 3,
    "div": 4,
    "sub": 5,
    "cndjmp": 6,
    "gt": 7,
    "lt": 8,
    "or": 9,
    "xor": 10,
    "and": 11,
    "inv": 12,
    "eq": 13,
    "neq": 14,
    "sl": 15,
    "sr": 16,
    "int": 17,
    "lda": 18,
    "sta": 19,
    "push": 20,
    "pop": 21,
    "incr": 22,
    "decr": 23,
    "hlt": 24,
    "sqrt": 25,
    "call": 26,
    "cndcall": 27,
    "pow": 28,
    "clr": 29,
    "mod": 30,
    "emi": 31,
    "ret": 32,
    "iret": 33,
    "rand": 34,
    "lteq": 35,
    "gteq": 36,
    "pri": 37,
    "eni": 38
};
const $89606a79fcd6d3b6$export$d0584c88f433914d = {};
for(const itn in $89606a79fcd6d3b6$export$a8647fae84abf3c8)$89606a79fcd6d3b6$export$d0584c88f433914d[$89606a79fcd6d3b6$export$a8647fae84abf3c8[itn]] = itn;
const $89606a79fcd6d3b6$export$ab0d25692b300f0a = {};
for(const ipt in $89606a79fcd6d3b6$export$3eaa7541cf5eefb2)$89606a79fcd6d3b6$export$ab0d25692b300f0a[$89606a79fcd6d3b6$export$3eaa7541cf5eefb2[ipt]] = ipt;

});
parcelRegister("dLq9J", function(module, exports) {

$parcel$export(module.exports, "wrap", () => $0e112480d1414235$export$4997ffc0176396a6);
$parcel$export(module.exports, "proxy", () => $0e112480d1414235$export$923f96dd5afa9ce6);
$parcel$export(module.exports, "transfer", () => $0e112480d1414235$export$c9b234447cf4ef7c);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $0e112480d1414235$export$be5234c0b764b6e0 = Symbol("Comlink.proxy");
const $0e112480d1414235$export$39fb953702b7fcd7 = Symbol("Comlink.endpoint");
const $0e112480d1414235$export$89981d4b8d9f48aa = Symbol("Comlink.releaseProxy");
const $0e112480d1414235$export$ddc31dfe7c269837 = Symbol("Comlink.finalizer");
const $0e112480d1414235$var$throwMarker = Symbol("Comlink.thrown");
const $0e112480d1414235$var$isObject = (val)=>typeof val === "object" && val !== null || typeof val === "function";
/**
 * Internal transfer handle to handle objects marked to proxy.
 */ const $0e112480d1414235$var$proxyTransferHandler = {
    canHandle: (val)=>$0e112480d1414235$var$isObject(val) && val[$0e112480d1414235$export$be5234c0b764b6e0],
    serialize (obj) {
        const { port1: port1, port2: port2 } = new MessageChannel();
        $0e112480d1414235$export$9b7f6e342a8cbd38(obj, port1);
        return [
            port2,
            [
                port2
            ]
        ];
    },
    deserialize (port) {
        port.start();
        return $0e112480d1414235$export$4997ffc0176396a6(port);
    }
};
/**
 * Internal transfer handler to handle thrown exceptions.
 */ const $0e112480d1414235$var$throwTransferHandler = {
    canHandle: (value)=>$0e112480d1414235$var$isObject(value) && $0e112480d1414235$var$throwMarker in value,
    serialize ({ value: value }) {
        let serialized;
        if (value instanceof Error) serialized = {
            isError: true,
            value: {
                message: value.message,
                name: value.name,
                stack: value.stack
            }
        };
        else serialized = {
            isError: false,
            value: value
        };
        return [
            serialized,
            []
        ];
    },
    deserialize (serialized) {
        if (serialized.isError) throw Object.assign(new Error(serialized.value.message), serialized.value);
        throw serialized.value;
    }
};
/**
 * Allows customizing the serialization of certain values.
 */ const $0e112480d1414235$export$ab8f1c00731ee83e = new Map([
    [
        "proxy",
        $0e112480d1414235$var$proxyTransferHandler
    ],
    [
        "throw",
        $0e112480d1414235$var$throwTransferHandler
    ]
]);
function $0e112480d1414235$var$isAllowedOrigin(allowedOrigins, origin) {
    for (const allowedOrigin of allowedOrigins){
        if (origin === allowedOrigin || allowedOrigin === "*") return true;
        if (allowedOrigin instanceof RegExp && allowedOrigin.test(origin)) return true;
    }
    return false;
}
function $0e112480d1414235$export$9b7f6e342a8cbd38(obj, ep = globalThis, allowedOrigins = [
    "*"
]) {
    ep.addEventListener("message", function callback(ev) {
        if (!ev || !ev.data) return;
        if (!$0e112480d1414235$var$isAllowedOrigin(allowedOrigins, ev.origin)) {
            console.warn(`Invalid origin '${ev.origin}' for comlink proxy`);
            return;
        }
        const { id: id, type: type, path: path } = Object.assign({
            path: []
        }, ev.data);
        const argumentList = (ev.data.argumentList || []).map($0e112480d1414235$var$fromWireValue);
        let returnValue;
        try {
            const parent = path.slice(0, -1).reduce((obj, prop)=>obj[prop], obj);
            const rawValue = path.reduce((obj, prop)=>obj[prop], obj);
            switch(type){
                case "GET" /* MessageType.GET */ :
                    returnValue = rawValue;
                    break;
                case "SET" /* MessageType.SET */ :
                    parent[path.slice(-1)[0]] = $0e112480d1414235$var$fromWireValue(ev.data.value);
                    returnValue = true;
                    break;
                case "APPLY" /* MessageType.APPLY */ :
                    returnValue = rawValue.apply(parent, argumentList);
                    break;
                case "CONSTRUCT" /* MessageType.CONSTRUCT */ :
                    {
                        const value = new rawValue(...argumentList);
                        returnValue = $0e112480d1414235$export$923f96dd5afa9ce6(value);
                    }
                    break;
                case "ENDPOINT" /* MessageType.ENDPOINT */ :
                    {
                        const { port1: port1, port2: port2 } = new MessageChannel();
                        $0e112480d1414235$export$9b7f6e342a8cbd38(obj, port2);
                        returnValue = $0e112480d1414235$export$c9b234447cf4ef7c(port1, [
                            port1
                        ]);
                    }
                    break;
                case "RELEASE" /* MessageType.RELEASE */ :
                    returnValue = undefined;
                    break;
                default:
                    return;
            }
        } catch (value) {
            returnValue = {
                value: value,
                [$0e112480d1414235$var$throwMarker]: 0
            };
        }
        Promise.resolve(returnValue).catch((value)=>{
            return {
                value: value,
                [$0e112480d1414235$var$throwMarker]: 0
            };
        }).then((returnValue)=>{
            const [wireValue, transferables] = $0e112480d1414235$var$toWireValue(returnValue);
            ep.postMessage(Object.assign(Object.assign({}, wireValue), {
                id: id
            }), transferables);
            if (type === "RELEASE" /* MessageType.RELEASE */ ) {
                // detach and deactive after sending release response above.
                ep.removeEventListener("message", callback);
                $0e112480d1414235$var$closeEndPoint(ep);
                if ($0e112480d1414235$export$ddc31dfe7c269837 in obj && typeof obj[$0e112480d1414235$export$ddc31dfe7c269837] === "function") obj[$0e112480d1414235$export$ddc31dfe7c269837]();
            }
        }).catch((error)=>{
            // Send Serialization Error To Caller
            const [wireValue, transferables] = $0e112480d1414235$var$toWireValue({
                value: new TypeError("Unserializable return value"),
                [$0e112480d1414235$var$throwMarker]: 0
            });
            ep.postMessage(Object.assign(Object.assign({}, wireValue), {
                id: id
            }), transferables);
        });
    });
    if (ep.start) ep.start();
}
function $0e112480d1414235$var$isMessagePort(endpoint) {
    return endpoint.constructor.name === "MessagePort";
}
function $0e112480d1414235$var$closeEndPoint(endpoint) {
    if ($0e112480d1414235$var$isMessagePort(endpoint)) endpoint.close();
}
function $0e112480d1414235$export$4997ffc0176396a6(ep, target) {
    const pendingListeners = new Map();
    ep.addEventListener("message", function handleMessage(ev) {
        const { data: data } = ev;
        if (!data || !data.id) return;
        const resolver = pendingListeners.get(data.id);
        if (!resolver) return;
        try {
            resolver(data);
        } finally{
            pendingListeners.delete(data.id);
        }
    });
    return $0e112480d1414235$var$createProxy(ep, pendingListeners, [], target);
}
function $0e112480d1414235$var$throwIfProxyReleased(isReleased) {
    if (isReleased) throw new Error("Proxy has been released and is not useable");
}
function $0e112480d1414235$var$releaseEndpoint(ep) {
    return $0e112480d1414235$var$requestResponseMessage(ep, new Map(), {
        type: "RELEASE" /* MessageType.RELEASE */ 
    }).then(()=>{
        $0e112480d1414235$var$closeEndPoint(ep);
    });
}
const $0e112480d1414235$var$proxyCounter = new WeakMap();
const $0e112480d1414235$var$proxyFinalizers = "FinalizationRegistry" in globalThis && new FinalizationRegistry((ep)=>{
    const newCount = ($0e112480d1414235$var$proxyCounter.get(ep) || 0) - 1;
    $0e112480d1414235$var$proxyCounter.set(ep, newCount);
    if (newCount === 0) $0e112480d1414235$var$releaseEndpoint(ep);
});
function $0e112480d1414235$var$registerProxy(proxy, ep) {
    const newCount = ($0e112480d1414235$var$proxyCounter.get(ep) || 0) + 1;
    $0e112480d1414235$var$proxyCounter.set(ep, newCount);
    if ($0e112480d1414235$var$proxyFinalizers) $0e112480d1414235$var$proxyFinalizers.register(proxy, ep, proxy);
}
function $0e112480d1414235$var$unregisterProxy(proxy) {
    if ($0e112480d1414235$var$proxyFinalizers) $0e112480d1414235$var$proxyFinalizers.unregister(proxy);
}
function $0e112480d1414235$var$createProxy(ep, pendingListeners, path = [], target = function() {}) {
    let isProxyReleased = false;
    const proxy = new Proxy(target, {
        get (_target, prop) {
            $0e112480d1414235$var$throwIfProxyReleased(isProxyReleased);
            if (prop === $0e112480d1414235$export$89981d4b8d9f48aa) return ()=>{
                $0e112480d1414235$var$unregisterProxy(proxy);
                $0e112480d1414235$var$releaseEndpoint(ep);
                pendingListeners.clear();
                isProxyReleased = true;
            };
            if (prop === "then") {
                if (path.length === 0) return {
                    then: ()=>proxy
                };
                const r = $0e112480d1414235$var$requestResponseMessage(ep, pendingListeners, {
                    type: "GET" /* MessageType.GET */ ,
                    path: path.map((p)=>p.toString())
                }).then($0e112480d1414235$var$fromWireValue);
                return r.then.bind(r);
            }
            return $0e112480d1414235$var$createProxy(ep, pendingListeners, [
                ...path,
                prop
            ]);
        },
        set (_target, prop, rawValue) {
            $0e112480d1414235$var$throwIfProxyReleased(isProxyReleased);
            // FIXME: ES6 Proxy Handler `set` methods are supposed to return a
            // boolean. To show good will, we return true asynchronously ¯\_(ツ)_/¯
            const [value, transferables] = $0e112480d1414235$var$toWireValue(rawValue);
            return $0e112480d1414235$var$requestResponseMessage(ep, pendingListeners, {
                type: "SET" /* MessageType.SET */ ,
                path: [
                    ...path,
                    prop
                ].map((p)=>p.toString()),
                value: value
            }, transferables).then($0e112480d1414235$var$fromWireValue);
        },
        apply (_target, _thisArg, rawArgumentList) {
            $0e112480d1414235$var$throwIfProxyReleased(isProxyReleased);
            const last = path[path.length - 1];
            if (last === $0e112480d1414235$export$39fb953702b7fcd7) return $0e112480d1414235$var$requestResponseMessage(ep, pendingListeners, {
                type: "ENDPOINT" /* MessageType.ENDPOINT */ 
            }).then($0e112480d1414235$var$fromWireValue);
            // We just pretend that `bind()` didn’t happen.
            if (last === "bind") return $0e112480d1414235$var$createProxy(ep, pendingListeners, path.slice(0, -1));
            const [argumentList, transferables] = $0e112480d1414235$var$processArguments(rawArgumentList);
            return $0e112480d1414235$var$requestResponseMessage(ep, pendingListeners, {
                type: "APPLY" /* MessageType.APPLY */ ,
                path: path.map((p)=>p.toString()),
                argumentList: argumentList
            }, transferables).then($0e112480d1414235$var$fromWireValue);
        },
        construct (_target, rawArgumentList) {
            $0e112480d1414235$var$throwIfProxyReleased(isProxyReleased);
            const [argumentList, transferables] = $0e112480d1414235$var$processArguments(rawArgumentList);
            return $0e112480d1414235$var$requestResponseMessage(ep, pendingListeners, {
                type: "CONSTRUCT" /* MessageType.CONSTRUCT */ ,
                path: path.map((p)=>p.toString()),
                argumentList: argumentList
            }, transferables).then($0e112480d1414235$var$fromWireValue);
        }
    });
    $0e112480d1414235$var$registerProxy(proxy, ep);
    return proxy;
}
function $0e112480d1414235$var$myFlat(arr) {
    return Array.prototype.concat.apply([], arr);
}
function $0e112480d1414235$var$processArguments(argumentList) {
    const processed = argumentList.map($0e112480d1414235$var$toWireValue);
    return [
        processed.map((v)=>v[0]),
        $0e112480d1414235$var$myFlat(processed.map((v)=>v[1]))
    ];
}
const $0e112480d1414235$var$transferCache = new WeakMap();
function $0e112480d1414235$export$c9b234447cf4ef7c(obj, transfers) {
    $0e112480d1414235$var$transferCache.set(obj, transfers);
    return obj;
}
function $0e112480d1414235$export$923f96dd5afa9ce6(obj) {
    return Object.assign(obj, {
        [$0e112480d1414235$export$be5234c0b764b6e0]: true
    });
}
function $0e112480d1414235$export$f2c03fb5a6c19546(w, context = globalThis, targetOrigin = "*") {
    return {
        postMessage: (msg, transferables)=>w.postMessage(msg, targetOrigin, transferables),
        addEventListener: context.addEventListener.bind(context),
        removeEventListener: context.removeEventListener.bind(context)
    };
}
function $0e112480d1414235$var$toWireValue(value) {
    for (const [name, handler] of $0e112480d1414235$export$ab8f1c00731ee83e)if (handler.canHandle(value)) {
        const [serializedValue, transferables] = handler.serialize(value);
        return [
            {
                type: "HANDLER" /* WireValueType.HANDLER */ ,
                name: name,
                value: serializedValue
            },
            transferables
        ];
    }
    return [
        {
            type: "RAW" /* WireValueType.RAW */ ,
            value: value
        },
        $0e112480d1414235$var$transferCache.get(value) || []
    ];
}
function $0e112480d1414235$var$fromWireValue(value) {
    switch(value.type){
        case "HANDLER" /* WireValueType.HANDLER */ :
            return $0e112480d1414235$export$ab8f1c00731ee83e.get(value.name).deserialize(value.value);
        case "RAW" /* WireValueType.RAW */ :
            return value.value;
    }
}
function $0e112480d1414235$var$requestResponseMessage(ep, pendingListeners, msg, transfers) {
    return new Promise((resolve)=>{
        const id = $0e112480d1414235$var$generateUUID();
        pendingListeners.set(id, resolve);
        if (ep.start) ep.start();
        ep.postMessage(Object.assign({
            id: id
        }, msg), transfers);
    });
}
function $0e112480d1414235$var$generateUUID() {
    return new Array(4).fill(0).map(()=>Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString(16)).join("-");
}

});

parcelRegister("8N69w", function(module, exports) {

var $9Gjfd = parcelRequire("9Gjfd");
let $6667ac165ba2182f$var$url = new URL(import.meta.resolve("lqaUV"));
module.exports = $9Gjfd($6667ac165ba2182f$var$url.toString(), $6667ac165ba2182f$var$url.origin, true);

});
parcelRegister("9Gjfd", function(module, exports) {
"use strict";
module.exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};

});



parcelRegister("bHLtA", function(module, exports) {

$parcel$export(module.exports, "setVersion", () => $885889a166d03410$export$f99c3c9c04cda7ae);
function $885889a166d03410$export$f99c3c9c04cda7ae() {
    fetch("/ver").then((response)=>response.text()).then((data)=>{
        let hash = data.split(/\r?\n/)[0];
        let time = data.split(/\r?\n/)[1];
        let commitMessage = data.split(/\r?\n/)[2];
        document.getElementById("version").textContent = `${hash.substring(0, 10)}`;
        document.getElementById("version").setAttribute("href", `https://github.com/sccreeper/goputer/commit/${hash}`);
        document.getElementById("build-date").textContent = time;
        document.getElementById("version").setAttribute("title", commitMessage);
    }).catch((reason)=>{
        document.getElementById("build-date").textContent = `Unable to fetch version: ${reason}`;
    });
}

});


//# sourceMappingURL=web.7c552b00.js.map
